export const invalidChars = {
	plus: '+',
	eKey: 'e'
};
export const minDynamicCharacterWidth = 1;
export const maxDynamicCharacterWidth = 4;
